import styled from 'styled-components'
import {DatePicker} from '@mui/x-date-pickers'
import {Button, Tabs} from '@mui/material'
import {TitleLink} from '@components/UI/styled'
import {StyledFormControl} from '@components/UI/styled'

export const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid #c4c4c4;
`

export const FiltersFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 810px) {
    width: 60%;
  }

  @media screen and (max-width: 550px) {
    width: 100%;
  }
`

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 32px;

  @media screen and (max-width: 550px) {
    width: 100%;
    align-items: flex-start;
    flex-direction: column-reverse;
    margin-top: 20px;
  }
`

export const DatePickersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  @media screen and (max-width: 810px) {
    flex-direction: column;
    width: 100%;
  }
`

export const DatePickerWrapper = styled.div`
  width: 280px;
  margin-left: 15px;

  &:first-child {
    margin-left: 0px;
  }

  @media screen and (max-width: 810px) {
    width: 100%;
    margin-top: 12px;
    margin-left: 0px;

    &:first-child {
      margin-top: 0px;
    }
  }

  @media screen and (max-width: 550px) {
    &:first-child {
      margin-top: 20px;
    }
  }
`

export const SearchControlWrapper = styled(StyledFormControl)`
  margin-top: 12px;
  width: 575px;

  @media screen and (max-width: 810px) {
    width: 100%;
    margin-left: 0;
  }
`

export const KeyboardDatePickerWrapper = styled(DatePicker)`
  display: flex;
  width: 100%;
  & input {
    padding: 0;
  }

  @media (max-width: 810px) {
    width: 100%;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: auto;

  @media (max-width: 810px) {
    width: calc(40% - 15px);
  }

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
  }
`

export const TitleLinkWrapper = styled(TitleLink)`
  @media (max-width: 550px) {
    width: 100%;
  }
`

export const ButtonWrapper = styled(Button)`
  width: 200px;
  box-shadow: none;
  margin-top: 12px;

  &:first-child {
    margin-top: 0px;
  }

  @media (max-width: 550px) {
    margin-top: 12px;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`
